const measurement =
{
    dimension : 'Dimension',
    separator : ' ',
    unit      : 'Unité',
    value     : 'Valeur',
    unknown   : 'Inconnu'
};

export default measurement ;